module.exports = __webpack_public_path__ + "media/images/icons/vendors/agency-ddf41988fa365ff8c1929208845a9afa.png";